import { render } from "./Remove.vue?vue&type=template&id=2703f606"
import script from "./Remove.js?vue&type=script&lang=js"
export * from "./Remove.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__